import { useQuery } from '@tanstack/react-query';

import { getTimeOffTypeById } from '../../api/time-offs.api';

export const TIME_OFF_TYPE_DETAIL_QUERY_KEY = (id: number) =>
  ['time-off-types', 'detail', id] as const;

const TIME_OFF_TYPE_STALE_TIME = 1 * 60 * 60 * 1000;

export const useTimeOffTypeDetails = (id: number) =>
  useQuery({
    queryKey: TIME_OFF_TYPE_DETAIL_QUERY_KEY(id),
    queryFn: () => getTimeOffTypeById(id),
    enabled: Number.isFinite(id),
    staleTime: TIME_OFF_TYPE_STALE_TIME,
  });
